module.exports = __webpack_public_path__ + "static/media/2.6f1037c7.jpg";